/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Feb 17 2025
 **/

import { CSSProperties } from "react";
import styled from "@emotion/styled";

import { Column } from "@/frameworks/designStuff/components";

export const VideoControlsWrapper = styled.div`
	position: absolute;
	width: 100%;
	height: 30px;
	bottom: 0;
	background-color: transparent;
	z-index: 2;
`;

export const VideoViewerWrap = styled(Column)`
	padding-top: 60px;
	padding-bottom: 30px;
	width: 100%;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.primary_70_100};
	scrollbar-color: ${({ theme }) => theme.colors.neutral_30_100} transparent;
	& > .react-transform-wrapper {
		height: 100%;
		width: 100%;
	}

	&::-webkit-scrollbar-track: {
		background: transparent;
	}
	&::webkit-scrollbar-thumb: {
		background-color: ${({ theme }) => theme.colors.neutral_30_100};
	}
`;

export const VideoRaycastTarget = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
`;

/* Mobile */
export const TransformComponentMobileStyle: CSSProperties = {
	width: "100%",
	height: "100%",
	visibility: "visible",
	position: "absolute",
	display: "flex",
	alignItems: "center"
};

export const TransformWrapperMobileStyle: CSSProperties = {
	marginTop: "30px",
	width: "100%",
	height: "calc(100% - 90px)"
};
